import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Form, InputNumber } from 'antd';
import DisabledContext from 'antd/es/config-provider/DisabledContext';

const PercentageInput = ({
  name,
  label,
  rules,
  onChange,
  required,
  disabled,
  hasFeedback,
  ...props
}) => {
  const formDisabled = useContext(DisabledContext);
  const defaultRule = [
    {
      required,
      message: 'El campo es requerido',
    },
  ];
  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules || defaultRule}
      hasFeedback={hasFeedback}
    >
      <InputNumber
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        className={disabled || formDisabled ? 'custom-input-disabled' : ''}
        allowClear={hasFeedback || !disabled}
        onChange={onChange}
        style={{ width: '100%' }}
        disabled={disabled || formDisabled}
        formatter={(value) => `${value}%`}
        parser={(value) => value.replace('%', '')}
      />
    </Form.Item>
  );
};

PercentageInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  // eslint-disable-next-line react/forbid-prop-types
  rules: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hasFeedback: PropTypes.bool,
};

PercentageInput.defaultProps = {
  rules: null,
  onChange: null,
  required: false,
  disabled: false,
  hasFeedback: true,
  label: '',
};

export default PercentageInput;
